import * as React from "react";
import { EditComponent, CustomComponentProps, CreateComponent } from "src/components/common/Component";


export function TeritoryEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["name"]} children={children} />
    );
}

export function TeritoryCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"teritory"} children={children} />
    );
}
